import React, { ReactNode } from "react";
import { LabelMedium } from "baseui/typography";
import { useStyletron } from "baseui";
import { Heading, HeadingLevel } from "baseui/heading";

export function PageTitle({
  title,
  subtitle,
  children,
  dataTest,
}: {
  title?: string;
  subtitle?: string;
  children?: ReactNode;
  dataTest?: string;
}) {
  const [, theme] = useStyletron();
  return (
    <HeadingLevel>
      <Heading
        styleLevel={6}
        margin={0}
        $style={{
          [theme.mediaQuery.medium]: {
            fontSize: theme.typography.HeadingLarge.fontSize,
            lineHeight: theme.typography.HeadingLarge.lineHeight,
          },
        }}
        data-test={dataTest}
      >
        {title}
      </Heading>
      {subtitle && (
        <LabelMedium color={theme.colors.contentTertiary} margin={0}>
          {subtitle}
        </LabelMedium>
      )}
      {children}
    </HeadingLevel>
  );
}
